import React, { useState } from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { motion } from 'framer-motion';

const FAQS = [
  {
    q: '¿Qué incluye el servicio de catering?',
    a: 'Dependiendo del formato elegido, el servicio puede incluir desde la entrega de bandejas listas para servir hasta el montaje completo del espacio con vajilla, decoración y personal especializado.',
  },
  {
    q: '¿Podéis trabajar en cualquier ubicación?',
    a: 'De momento, ofrecemos servicio en la Comunidad de Madrid y alrededores. Cuéntanos tu ubicación y la fecha del evento y valoraremos la propuesta sin compromiso.',
  },
  {
    q: '¿Hay opciones para personas con restricciones alimentarias?',
    a: 'Por supuesto. Indícanos las necesidades de tus invitados y adaptaremos el menú.',
  },
  {
    q: '¿Con cuánta antelación hay que reservar?',
    a: 'Recomendamos contactar con al menos 2–4 semanas de antelación para eventos medianos, y con más tiempo para bodas y eventos de gran formato.',
  },
  {
    q: '¿Puedo personalizar el menú?',
    a: 'Sí. Trabajamos contigo para diseñar el menú que mejor se adapte a tus gustos, el número de comensales y el presupuesto.',
  },
  {
    q: '¿Qué espacio necesito para el catering con sushiman?',
    a: 'El sushiman necesita una zona de trabajo de aproximadamente 2×1 m con acceso a agua. Nos adaptamos a las condiciones de tu espacio.',
  },
];

const FAQ: React.FC = () => {
  const [expanded, setExpanded] = useState<number | false>(false);

  return (
    <Box id="faq" sx={{ py: 10, background: 'var(--color-bg)' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="overline"
            align="center"
            sx={{ display: 'block', color: 'var(--color-accent)', letterSpacing: '0.3em', mb: 1 }}
          >
            Preguntas frecuentes
          </Typography>
          <Typography
            variant="h2"
            align="center"
            sx={{ fontFamily: 'var(--font-heading)', fontSize: { xs: '1.8rem', md: '2.5rem' }, mb: 8 }}
          >
            Resolvemos tus dudas
          </Typography>
        </motion.div>

        <Box>
          {FAQS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
            >
              <Accordion
                expanded={expanded === i}
                onChange={(_, isExpanded) => setExpanded(isExpanded ? i : false)}
                sx={{
                  bgcolor: 'var(--color-bg-card)',
                  border: '1px solid',
                  borderColor: expanded === i ? 'var(--color-accent)' : 'var(--color-border)',
                  borderRadius: '8px !important',
                  mb: 1.5,
                  transition: 'border-color 0.25s',
                  '&:before': { display: 'none' },
                  boxShadow: expanded === i ? '0 0 20px rgba(200,169,110,0.07)' : 'none',
                }}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === i
                      ? <RemoveIcon sx={{ color: 'var(--color-accent)', fontSize: 20 }} />
                      : <AddIcon sx={{ color: 'var(--color-text-secondary)', fontSize: 20 }} />
                  }
                  sx={{ px: 3, py: 1.25 }}
                >
                  <Typography sx={{ color: 'var(--color-text-primary)', fontWeight: 500, fontSize: '0.97rem' }}>
                    {item.q}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
                  <Typography sx={{ color: 'var(--color-text-secondary)', lineHeight: 1.85, fontSize: '0.92rem' }}>
                    {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </motion.div>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQ;
